import React from 'react';
import PropTypes from 'prop-types';
import Mutation from '@dietlabs/components/src/Apollo/Mutation';
import NewsletterUnsubscribeMutation from './NewsletterUnsubscribeMutation';

class NewsletterUnsubscribeConnectorApollo extends React.Component {
    static propTypes = {
        children: PropTypes.func.isRequired,
    };

    createUnsubscribe = mutate => async request => {
        const variables = request;

        const response = await mutate({
            variables,
        });

        return response;
    };

    render() {
        const { children } = this.props;

        return (
            <Mutation mutation={NewsletterUnsubscribeMutation}>
                {mutate =>
                    children({
                        unsubscribe: this.createUnsubscribe(mutate),
                    })
                }
            </Mutation>
        );
    }
}

export default NewsletterUnsubscribeConnectorApollo;
